module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sekundaerlogo_postale_oslo_viken_neg.7ed69f6e.svg";